<template>
    <v-container class="no-padding-mobile no-padding-top" fluid>
        <v-layout>
            <v-flex xs12 lg10 offset-lg1 xl8 offset-xl2 class="no-padding-top">
                <TrapList show-new show-filter pagination />
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import loadingMixin from "@/mixins/loading"
import TrapList from "@/components/TrapList"
import { mapGetters, mapActions } from "vuex"
import Vue from "vue"
export default {
    components: { TrapList },
    mixins: [loadingMixin],
    data() {
        return {}
    },
}
</script>
